import React from "react";
import { Check } from "lucide-react";
import Button from "components/Button";

import styles from "./StripeProvider.module.scss";
import { ReactComponent as StripeLogo } from "assets/icons/stripe_s_logo.svg";

interface StripeProviderProps {
  isConnected: boolean;
  connectedDate?: string;
  onAction: () => void;
  loading?: boolean;
}

const StripeProvider: React.FC<StripeProviderProps> = ({
  isConnected,
  connectedDate,
  onAction,
  loading = false,
}) => {
  return (
    <div className={styles.stripeDetails}>
      <div className={styles.providerInfo}>
        <div className={styles.providerMain}>
          <div className={styles.iconWrapper}>
            <StripeLogo className={styles.stripeLogo} />
          </div>
          <div className={styles.name}>
            Stripe
            {isConnected && <Check size={20} className={styles.checkIcon} />}
          </div>
        </div>
        {isConnected && connectedDate && (
          <span className={styles.connectedDate}>
            Connected Since: {connectedDate}
          </span>
        )}
      </div>
      <Button
        text={isConnected ? "Remove" : "Setup"}
        onClick={onAction}
        outlined={true}
        disabled={loading}
        variant={isConnected ? "danger" : "primary"}
      />
    </div>
  );
};

export default StripeProvider;
